import React from 'react';
import styled from 'styled-components';
import colors from '@honeybook/hbui/dist/styles/colors';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import spacing from '@honeybook/hbui/dist/styles/spacing';
import RightArrowIcon from '@honeybook/icons/dist/icons/ArrowRight8';
import HBTooltip from '@honeybook/hbui/dist/components/HBTooltip/HBTooltip';
import is from 'styled-is';

interface Props {
    visibleActions: string[];
    hiddenActions: string[];
}

const FlowGalleryCardActions = ({
    hiddenActions = [],
    visibleActions = []
}: Props) => {
    return (
        <FlowGalleryCardActionsContainer>
            <List>
                {visibleActions?.length > 0 && (
                    <>
                        {visibleActions?.map((action, index) => (
                            <FlowGalleryCardActionsListItem
                                key={action}
                                type="Body-Extra-small"
                                hasHiddenActions={hiddenActions?.length > 0}
                            >
                                {action}

                                {visibleActions?.length - 1 !== index && (
                                    <ArrowIcon color={colors.neutral800} />
                                )}
                            </FlowGalleryCardActionsListItem>
                        ))}
                    </>
                )}

                {hiddenActions?.length > 0 && (
                    <ListElemTooltip>
                        <HBTooltip
                            placement="top"
                            customStyle={{
                                maxWidth: '250px'
                            }}
                            target={
                                <FlowGalleryCardActionsListItem
                                    type="Body-Extra-small"
                                    hasHiddenActions
                                >
                                    <ArrowIcon color={colors.neutral800} />

                                    {`+ ${hiddenActions?.length} actions`}
                                </FlowGalleryCardActionsListItem>
                            }
                        >
                            <TooltipText>
                                {hiddenActions?.join(', ')}
                            </TooltipText>
                        </HBTooltip>
                    </ListElemTooltip>
                )}
            </List>
        </FlowGalleryCardActionsContainer>
    );
};

export default FlowGalleryCardActions;

/* styles */
export const FlowGalleryCardActionsContainer = styled.div`
    width: 100%;
    margin-top: ${spacing[12]};
    min-height: 15px;
`;

const List = styled.div`
    display: flex;
`;

const ListElemTooltip = styled.div`
    max-width: 95px;
`;

const TooltipText = styled.span`
    text-transform: capitalize;
`;

export const FlowGalleryCardActionsListItem = styled(HBText)<{
    hasHiddenActions?: boolean;
}>`
    display: flex;
    position: relative;
    align-items: center;
    padding-left: ${spacing[16]};

    &::before {
        content: '';
        width: 12px;
        height: 12px;
        display: block;
        position: absolute;
        top: 1px;
        left: 0;
        background-color: ${colors.white};
        border: 3px solid ${colors.blue10};
        border-radius: 100%;
    }

    ${is('hasHiddenActions')`
        &:last-child {
            padding-left: 0;

            &::before {
                display: none;
            }
        }
    `};
`;

const ArrowIcon = styled(RightArrowIcon)`
    padding: 0 9px 0 6px;
`;
